export default __webpack_public_path__ + "static/media/pre-tactical.39f6c02b.svg";